import { USPS_GENERAL_DELIVERY_ADDRESS } from '@constants/ssap/miscellaneous/miscellaneous';

export const normalizeAddress = (addressData, isUnitAttached = undefined, shouldOmitGeneralDelivery = undefined) => {
    const {
        streetAddress1,
        streetAddress2,
        city,
        state,
        postalCode
    } = addressData;

    const getAddress1 = () => {
        if (shouldOmitGeneralDelivery && streetAddress1 === USPS_GENERAL_DELIVERY_ADDRESS) {
            return null;
        }
        return streetAddress1;
    };

    const getUnitAttached = () => {
        if (isUnitAttached === undefined) {
            return '';
        }
        return 'Unit # ';
    };

    const getAddress2 = () => {
        if (streetAddress2) {
            return getUnitAttached() + streetAddress2;
        }
        return null;
    };

    const addressChunks = [
        getAddress1(),
        getAddress2(),
        city,
        state,
        postalCode
    ];

    const getCombinedAddress = () => {
        return addressChunks
            .filter(chunk => chunk !== null)
            .join(', ');
    };

    switch (true) {
        case !streetAddress1:
        case !city:
        case !state:
        case !postalCode:
            return '--NA-- ';
        default:
            return getCombinedAddress();
    }
};
